import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import { Layout, Box, useMedia } from './Boneyard';
import PrintAware from './PrintAware';
import WrappedSiteFooter from './siteLayout/WrappedSiteFooter';
import SiteHeader from './siteLayout/SiteHeader';
import styled, { withTheme } from 'styled-components';
import BOOKING_PATH_BACKGROUND from './stadiumBookingPathBackground.query';
import { useSSRQuery, useBookingPath } from '../graphql';

const BackgroundImageContainer = styled.div`
  background-image: url(${props => props.image});
  background-color: ${props => props.theme.colors.bookingBackground.background};
  background-position: center top;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
`;

const SiteLayout = withTheme(
  ({ theme, title, children, withDefaultPadding = true, ...props }) => {
    const { data } = useSSRQuery(BOOKING_PATH_BACKGROUND);
    const stadiumBookingPathBackground = data?.application?.images.find(
      image => image.id === 'stadiumBookingPathBackground'
    )?.path;
    const { isStadium } = useBookingPath();
    const mq = useMedia();

    return (
      <Layout>
        <Head>
          <title>{title}</title>
        </Head>
        <SiteHeader isStadium={isStadium} pageContext={title} {...props} />
        {withDefaultPadding ? (
          isStadium ? (
            <BackgroundImageContainer image={stadiumBookingPathBackground}>
              <Layout.Main>
                <Layout.Content>
                  {/* TODO: find a better solution to remove white space below header */}
                  <div id="main" style={{ paddingTop: 1 }}>
                    {children}
                  </div>
                </Layout.Content>
              </Layout.Main>
            </BackgroundImageContainer>
          ) : (
            <Layout.Main>
              <Layout.Content>
                {/* TODO: find a better solution to remove white space below header */}
                <div id="main" style={{ paddingTop: 1 }}>
                  {children}
                </div>
              </Layout.Content>
            </Layout.Main>
          )
        ) : (
          <Box
            backgroundColor={
              mq.lt('sm')
                ? theme.colors.siteLayout.background.sm
                : theme.colors.siteLayout.background.default
            }
          >
            <div id="main" style={{ paddingTop: 1 }}>
              {children}
            </div>
          </Box>
        )}
        <PrintAware>
          <WrappedSiteFooter />
        </PrintAware>
      </Layout>
    );
  }
);

SiteLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  theme: PropTypes.object,
};

export default SiteLayout;
